const Footer = ({ gameState, saveSpace }) => {
  return (
    <div>
      {gameState?.gameName && (
        <div className={saveSpace ? "pb-1" : "pb-3"}>
          <div className="d-flex justify-content-center">
            <div className="gameNameBox">
              <p
                className="gameName shadow"
                style={{ fontSize: saveSpace ? "0.7rem" : "" }}
              >
                {gameState?.gameName}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Footer;
